(() => {
  'use strict';

const SELECTORS = {

  root: '#nvxSatcRoot',

  flavour: '#nvxSatcFlavour',

  meta: '#nvxSatcMeta',

  price: '#nvxSatcPrice',

  button: '#nvxSatcButton',

  productInfo: 'product-info',

  originalButton: '#main-add-to-cart',

  productForm: 'form[data-type="add-to-cart-form"]',

  largePrice: '[id^="price-"]',

  productTitle: '.product__title h1'

};



  let root;
  let flavour;
  let meta;
  let price;
  let button;

  let originalButton;

  let observer;

  function init(){

      root=document.querySelector(SELECTORS.root);

      if(!root){

          return;
      }

      flavour=root.querySelector(SELECTORS.flavour);
      
      meta=root.querySelector(SELECTORS.meta);

      price=root.querySelector(SELECTORS.price);

      button=root.querySelector(SELECTORS.button);

      originalButton=document.querySelector(SELECTORS.originalButton);

      if(!originalButton){

          return;
      }

      bindButton();

      createObserver();

      sync();

  }



  function bindButton(){

      button.addEventListener('click',()=>{

          originalButton.click();

      });

  }



  function createObserver(){

      const target=originalButton;

      observer=new IntersectionObserver((entries)=>{

          entries.forEach((entry)=>{

              if(entry.isIntersecting){

                  hide();

              }else{

                  show();

              }

          });

      },{

          threshold:0

      });

      observer.observe(target);

  }



  function show(){

      root.hidden=false;

      root.classList.add('nvxSatc--visible');

      root.setAttribute('aria-hidden','false');

  }



  function hide(){

      root.classList.remove('nvxSatc--visible');

      root.setAttribute('aria-hidden','true');

  }



  function sync(){

    syncFlavour();

    syncMeta();

    syncPrice();

    syncButton();

}



  function syncFlavour(){

    const source=document.querySelector('#selected-flavour .selected-option-value');

    if(source && flavour){

        flavour.innerHTML=source.textContent.trim();

    }

}

function syncMeta(){

    const weight=document.querySelector('#selected-size .selected-option-value');

    const servings=document.querySelector('.selected-serving');

    if(!meta) return;

    const weightText=weight ? weight.textContent.trim() : '';

    const servingsText=servings ? servings.textContent.trim() : '';

    if(weightText && servingsText){

        meta.innerHTML=`${weightText} • ${servingsText}`;

    }else if(weightText){

        meta.innerHTML=weightText;

    }else if(servingsText){

        meta.innerHTML=servingsText;

    }

}



  function syncPrice(){

      const source=document.querySelector(SELECTORS.largePrice);

      if(source){

          price.innerHTML=source.innerHTML;

      }

  }



  function syncButton(){

      button.disabled=originalButton.disabled;

      button.innerHTML=originalButton.innerHTML;

  }



  document.addEventListener('DOMContentLoaded',init);

})();